import { useState, useCallback } from 'react';

/**
 * Hook for month-based calendar navigation.
 */
export function useCalendarMonth() {
  const [state, setState] = useState(() => {
    const now = new Date();
    return { year: now.getFullYear(), month: now.getMonth() };
  });

  const prevMonth = useCallback(() => {
    setState(prev => {
      const m = prev.month - 1;
      return m < 0 ? { year: prev.year - 1, month: 11 } : { year: prev.year, month: m };
    });
  }, []);

  const nextMonth = useCallback(() => {
    setState(prev => {
      const m = prev.month + 1;
      return m > 11 ? { year: prev.year + 1, month: 0 } : { year: prev.year, month: m };
    });
  }, []);

  const monthLabel = new Date(state.year, state.month).toLocaleDateString('en-US', {
    month: 'long',
    year: 'numeric',
  });

  return { year: state.year, month: state.month, prevMonth, nextMonth, monthLabel } as const;
}
